import { connect } from 'react-redux';
import BetBuilderBets from '../../../components/betslip/BetBuilderBets/BetBuilderBets';

import {
  updateOfferByUser,
  submitEditedOffersByIds,
  submitEditedUnmatchedByIds,
  reviewOpenOffer,
  cancelOpenOffersByIds,
  cancelUnmatchedOpenOffersByIds
} from '@xanadu/ui-shared/modules/openOffers/actions';

const mapDispatchToProps = {
  onUpdateOffers: updateOfferByUser,
  onReviewOffer: reviewOpenOffer,
  onSubmitOffers: submitEditedOffersByIds,
  onSubmitUnmatched: submitEditedUnmatchedByIds,
  onCancelOffers: cancelOpenOffersByIds,
  onCancelUnmatchedOffers: cancelUnmatchedOpenOffersByIds,
};


const mapStateToProps = (state) => ({
  openOffers: state.getIn(['betBuilder', 'betBuilderOffers']),
  currency: state.getIn(['user', 'currency']),
});

export default connect(mapStateToProps, mapDispatchToProps)(BetBuilderBets);
